import { useCallback, useEffect, useState } from "react";
import { StockService } from "../../../../services/StockService";

export const useSpeciesOptions = () => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    StockService.GetAllSpecies().then((species) => {
      setOptions(
        (species || []).map((s) => ({
          ...s,
          value: s.speciesId,
          label: s.speciesCode ? `${s.speciesCode} — ${s.speciesName}` : s.speciesName,
        }))
      );
    });
  }, []);

  const speciesIdFor = useCallback((item) => item.speciesId || 0, []);

  const optionFor = useCallback(
    (item) => options.find((o) => o.value === speciesIdFor(item)) || null,
    [options, speciesIdFor]
  );

  return { options, speciesIdFor, optionFor };
};
